import React from 'react';

const SvgSwapvertical = ({ title, ...props }) => (
  <svg width={24} height={24} {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M18 4l-4 4h3v8a2 2 0 01-2 2 2 2 0 01-2-2V8a4 4 0 00-4-4 4 4 0 00-4 4v8H2l4 4 4-4H7V8a2 2 0 012-2 2 2 0 012 2v8a4 4 0 004 4 4 4 0 004-4V8h3l-4-4z" />
  </svg>
);

export default SvgSwapvertical;
